import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=567e891a"
import script from "./DetailDialog.vue?vue&type=script&lang=js"
export * from "./DetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567e891a')) {
      api.createRecord('567e891a', component.options)
    } else {
      api.reload('567e891a', component.options)
    }
    module.hot.accept("./DetailDialog.vue?vue&type=template&id=567e891a", function () {
      api.rerender('567e891a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/terminalRefund/components/DetailDialog.vue"
export default component.exports